import { EmptyState } from './ui'

export function DataTable({ columns, rows, emptyMessage = 'Nenhum registro.', rowKey }) {
  if (!rows?.length) {
    return <EmptyState title={emptyMessage} />
  }

  return (
    <div className="mp-scrollbar overflow-x-auto rounded-xl border border-slate-200">
      <table className="min-w-full divide-y divide-slate-200 text-sm">
        <thead className="bg-slate-50/90">
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                className="whitespace-nowrap px-4 py-3.5 text-left text-[11px] font-bold uppercase tracking-[0.08em] text-slate-500"
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100 bg-white">
          {rows.map((row, idx) => (
            <tr key={rowKey ? rowKey(row) : row.id ?? idx} className="transition-colors hover:bg-blue-50/40">
              {columns.map((col) => (
                <td key={col.key} className="px-4 py-3.5 text-slate-700">
                  {col.render ? col.render(row) : row[col.key] ?? '—'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
